export const flightArrangementTravelerOption = {
  reservedBaggageDisplay:
    "Up to {{weight}} {{weightUnit}}, {{quantity}} pieces ({{price}})",
};
